import type { Extensions } from "@tiptap/core";
import Blockquote from "@tiptap/extension-blockquote";
import Bold from "@tiptap/extension-bold";
import Heading from "@tiptap/extension-heading";
import Italic from "@tiptap/extension-italic";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import {
  BackgroundColor,
  Color,
  FontSize,
  TextStyle,
} from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";

import { DashedBulletList } from "./dashed-bullet-list";
import { SelectedTextClipboard } from "./selected-text-clipboard";
import { SlashCommand } from "./slash-command";

/**
 * Extensions enabled only in richText mode: inline marks (bold/italic/underline
 * plus color/highlight/font-size via TextStyle), block types (headings, lists,
 * quote), and the "/" slash-command menu. `includeSlash` is false for the
 * read-only renderer, which re-parses stored HTML but never needs the menu.
 */
export function buildRichTextExtensions(includeSlash: boolean): Extensions {
  return [
    Bold,
    Italic,
    Underline,
    Heading.configure({ levels: [1, 2, 3] }),
    DashedBulletList,
    OrderedList,
    ListItem,
    Blockquote,
    TextStyle,
    Color,
    BackgroundColor,
    FontSize,
    SelectedTextClipboard,
    ...(includeSlash ? [SlashCommand] : []),
  ];
}
